import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import PageShell from './PageShell';
import Education from './Education.js';
import Certification from './Certification.js';
import Experience from './Experience.js';
import Skills from './Skills.js';

class Resume extends Component {
    render() {
        return (
            <PageShell className="page-resume">
                <Grid className="resume-grid">
                    <Cell col={4} tablet={4} phone={12} className="resume-left-col">
                        <div className="resume-avatar-wrap">
                            <img
                                src="https://s3-ap-southeast-2.amazonaws.com/portfoliobucket.joseph/myAvatar+(2).png"
                                alt="Joseph Johney"
                                className="resume-avatar"
                            />
                        </div>
                        <h2 className="resume-name">Joseph Johney</h2>
                        <h4 className="resume-title">Solution Designer</h4>
                        <hr className="resume-divider resume-divider-accent" />
                        <div className="resume-bio">
                            <p>
                                Senior technology leader specializing in solution design, enterprise architecture, and large-scale digital transformation programs across banking and financial services. Currently a Solution Designer at National Australia Bank (NAB), delivering secure and scalable platforms using AWS, Azure, Google Cloud, Apigee, Mulesoft, Salesforce, and microservices architectures.
                            </p>
                            <ul>
                                <li>Solution Designer with 15+ years of experience in enterprise integration, cloud platforms, and banking technology</li>
                                <li>Driving digital transformation at major Australian banks including NAB and ANZ</li>
                                <li>Led the development team which received Telstra CIO award for best project (SIP Trunking on ASP) twice</li>
                                <li>Received Infosys 2019-20 H1 APAC excellence award for contributions to Telstra's Digitization program</li>
                                <li>Best contributor Award for Q4 FY 20 in Telstra Digital Adoption program</li>
                                <li>Part of the team which received Telstra CTO awards (SIP Trunking - Phase 2)</li>
                            </ul>
                            <p>
                                Recognized for stakeholder collaboration, solution ownership, and high-impact delivery in complex enterprise environments.
                            </p>
                        </div>
                        <hr className="resume-divider resume-divider-accent" />
                        <div className="resume-contact-block">
                            <h5>Address</h5>
                            <p>Melbourne</p>
                            <h5>Phone</h5>
                            <p>(+61) 0439473163</p>
                            <h5>Email</h5>
                            <p>josephjohney16@gmail.com</p>
                            <h5>Web</h5>
                            <p>josephjohney.com</p>
                        </div>
                    </Cell>
                    <Cell col={8} tablet={8} phone={12} className="resume-right-col">
                        <section className="resume-section">
                            <h3 className="resume-section-title">Certification</h3>
                            <Certification year={2024} name="Google Cloud Professional Cloud Architect" description="GCP" />
                            <Certification year={2023} name="AWS Solutions Architect – Professional" description="AWS" />
                            <Certification year={2022} name="AWS Solution Architect – Associate" description="AWS" />
                            <Certification year={2022} name="Google Cloud Certified - Cloud Digital Leader" description="GCP" />
                            <Certification year={2020} name="Azure Fundamentals" description="Microsoft Azure" />
                            <Certification year={2020} name="Developing APIs with Google Cloud's Apigee API Platform Specialization" description="GCP - Coursera" />
                            <Certification year={2019} name="Amazon Web Services Developer Associate" description="AWS" />
                            <Certification year={2014} name="ITIL Foundation Certificate in Service Management" description="ITIL" />
                            <Certification year={2012} name="Java Standard Edition 6 Programmer Certified Professional" description="Oracle" />
                        </section>

                        <section className="resume-section">
                            <h2 className="resume-section-title">Education</h2>
                            <Education
                                startYear={2005}
                                endYear={2009}
                                schoolName="College of Engineering, Trivandrum, Kerala University"
                                schoolDescription="Bachelor of Technology, Electronics and Communications Engineering"
                            />
                            <Education
                                startYear={2015}
                                endYear={2017}
                                schoolName="Birla Institute of Technology, Pilani, India"
                                schoolDescription="Master of Technology, Computer Systems"
                            />
                        </section>

                        <hr className="resume-divider resume-divider-highlight" />
                        <section className="resume-section">
                            <h2 className="resume-section-title">Experience</h2>
                            <Experience startYear={2024} jobName="National Australia Bank (NAB)" jobDescription="Solution Designer" jobRole="Enterprise Solution Design & Digital Transformation" />
                            <Experience startYear={2023} endYear={2024} jobName="ANZ Banking Group" jobDescription="Solution Designer" jobRole="Banking Technology & Integration Architecture" />
                            <Experience startYear={2021} endYear={2023} jobName="HCL Australia Services" jobDescription="Principal Solution Architect" jobRole="Enterprise Integration & Cloud Architecture Lead" />
                            <Experience startYear={2015} endYear={2021} jobName="Infosys Technologies" jobDescription="Technology Lead" jobRole="Staff Augmented Role : Integration Architect - Telstra" />
                            <Experience startYear={2012} endYear={2015} jobName="Infosys Technologies" jobDescription="Technology Analyst" jobRole="Integration Solutions and SaaS Platforms" />
                            <Experience startYear={2011} endYear={2012} jobName="Infosys Technologies" jobDescription="Senior Systems Engineer" jobRole="Enterprise Application Development" />
                            <Experience startYear={2009} endYear={2011} jobName="Infosys Technologies" jobDescription="Systems Engineer" jobRole="Application Development and Maintenance" />
                        </section>

                        <hr className="resume-divider resume-divider-highlight" />
                        <section className="resume-section">
                            <h2 className="resume-section-title">Skills</h2>
                            <Skills skill="Enterprise Architecture & Solution Design" progress={95} />
                            <Skills skill="Cloud Architecture (AWS/Azure/GCP)" progress={90} />
                            <Skills skill="Banking & Financial Services Domain" progress={90} />
                            <Skills skill="Apigee API Management" progress={95} />
                            <Skills skill="Mulesoft Integration" progress={85} />
                            <Skills skill="Salesforce / Vlocity" progress={80} />
                            <Skills skill="Java / Spring Boot" progress={90} />
                            <Skills skill="Microservices & Event-Driven Architecture" progress={90} />
                            <Skills skill="JavaScript / NodeJS / React" progress={75} />
                            <Skills skill="CI/CD & DevOps" progress={80} />
                        </section>
                    </Cell>
                </Grid>
            </PageShell>
        );
    }
}

export default Resume;
